// extracted by mini-css-extract-plugin
module.exports = {"title":"DeeplinkLoginForm_title__jaVwf","subtitle":"DeeplinkLoginForm_subtitle__E0tlI","inputLabel":"DeeplinkLoginForm_inputLabel__zprR3"};